module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/simplebar/node_modules/core-js/internals/is-pure.js
// module id = 127
// module chunks = 1